import React, { useEffect, useState } from "react";
import { API } from "../api";
import AnteprimaPage from "./AnteprimaPage";
import { Lock, Loader2, ArrowRight, Eye, EyeOff } from "lucide-react";

const AnteprimaGate = () => {
  const [status, setStatus] = useState("checking"); // checking | locked | unlocked
  const [password, setPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    // L'accesso all'anteprima è gestito da un cookie httpOnly (inviato automaticamente).
    fetch(`${API}/anteprima/verify`, { credentials: "include" })
      .then((r) => setStatus(r.ok ? "unlocked" : "locked"))
      .catch(() => setStatus("locked"));
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!password.trim()) { setError("Inserisci la password."); return; }
    setSubmitting(true);
    setError("");
    try {
      const res = await fetch(`${API}/anteprima/access`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password }),
      });
      if (res.ok) {
        setStatus("unlocked");
      } else if (res.status === 429) {
        setError("Troppi tentativi. Riprova tra qualche minuto.");
      } else {
        setError("Password non corretta.");
      }
    } catch {
      setError("Errore di connessione. Riprova.");
    } finally {
      setSubmitting(false);
    }
  };

  if (status === "unlocked") return <AnteprimaPage />;

  if (status === "checking") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0d1b2f] text-white" data-testid="anteprima-gate-loading">
        <Loader2 className="animate-spin" size={28} />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#16345c] via-[#12294a] to-[#0d1b2f] text-white px-6 relative overflow-hidden" data-testid="anteprima-gate">
      <div className="absolute -top-32 -right-32 w-[420px] h-[420px] rounded-full bg-[#ff7e00]/15 blur-[120px]" />
      <div className="absolute -bottom-40 -left-24 w-[380px] h-[380px] rounded-full bg-[#3f66b3]/20 blur-[120px]" />

      <div className="relative z-10 w-full max-w-sm">
        <div className="text-center mb-8">
          <span className="text-[28px] font-black tracking-tight">Tele<span className="text-[#ff7e00]">borsa</span> <span className="font-light text-[#ff7e00]">HR</span></span>
        </div>

        <div className="bg-white/5 border border-white/15 rounded-2xl p-8 backdrop-blur-sm">
          <span className="w-14 h-14 rounded-xl bg-[#ff7e00]/15 text-[#ff7e00] flex items-center justify-center mx-auto mb-5">
            <Lock size={26} />
          </span>
          <h1 className="text-[22px] font-black text-center leading-tight">Area riservata</h1>
          <p className="text-[13px] text-gray-300 text-center mt-2 mb-6">
            Inserisci la password per accedere all'anteprima del portale.
          </p>

          <form onSubmit={submit} className="space-y-4">
            <div className="relative">
              <input
                type={showPwd ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
                autoFocus
                data-testid="anteprima-gate-password"
                className="w-full bg-white/10 border border-white/20 focus:border-[#ff7e00] rounded-lg px-4 py-3 pr-11 text-[15px] text-white placeholder-gray-400 outline-none transition-colors"
              />
              <button type="button" onClick={() => setShowPwd((s) => !s)} data-testid="anteprima-gate-toggle" className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white transition-colors">
                {showPwd ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
            {error && <p className="text-[13px] text-[#ff9a9a] font-semibold" data-testid="anteprima-gate-error">{error}</p>}
            <button
              type="submit"
              disabled={submitting}
              data-testid="anteprima-gate-submit"
              className="w-full inline-flex items-center justify-center gap-2 bg-[#ff7e00] hover:bg-[#e66f00] text-[#0d1b2f] text-[15px] font-black px-6 py-3 rounded-lg transition-colors disabled:opacity-60"
            >
              {submitting ? <Loader2 className="animate-spin" size={18} /> : <>Accedi <ArrowRight size={18} /></>}
            </button>
          </form>
        </div>

        <p className="text-[12px] text-gray-500 text-center mt-6">Gruppo Teleborsa · Accesso riservato</p>
      </div>
    </div>
  );
};

export default AnteprimaGate;
